module.exports = __webpack_public_path__ + "img/Dantam Fashion 05.da424878.jpg";